import { render, staticRenderFns } from "./ArticleHeadlinesSection.vue?vue&type=template&id=71e41c80&scoped=true"
import script from "./ArticleHeadlinesSection.vue?vue&type=script&lang=ts"
export * from "./ArticleHeadlinesSection.vue?vue&type=script&lang=ts"
import style0 from "./ArticleHeadlinesSection.vue?vue&type=style&index=0&id=71e41c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e41c80",
  null
  
)

export default component.exports